import React from 'react';

import { Chip, ChipProps } from '@mui/material';

// TODO: Remove isProduction guard and legacy status mapping once Phase 5 DB migration is complete (LEBT-2153)
const LEGACY_AVAILABLE_STATUSES = ['PENDING', 'EXPIRED'];
const isProduction = process.env.NODE_ENV === 'production';

export function getDisplayStatus(status: string): string {
  if (!status) {
    return '';
  }
  if (status === 'AVAILABLE') {
    return 'AVAILABLE';
  }
  if (!isProduction && LEGACY_AVAILABLE_STATUSES.includes(status)) {
    return 'AVAILABLE';
  }
  return status.toUpperCase();
}

const STATUS_COLOR_MAP: Record<string, ChipProps['color']> = {
  AVAILABLE: 'warning',
  PENDING: 'warning',
  ACTIVATED: 'success',
};

function getStatusColor(displayStatus: string): ChipProps['color'] {
  return STATUS_COLOR_MAP[displayStatus] ?? 'error';
}

export default function EmployeeStatusCell({ status }: { status: string }) {
  const displayStatus = getDisplayStatus(status);
  if (!displayStatus) {
    return null;
  }
  return <Chip label={displayStatus} color={getStatusColor(displayStatus)} size="small" />;
}
